import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-requests',
  templateUrl: './no-requests.component.html',
  styleUrls: ['./no-requests.component.scss'],
})
export class NoRequestsComponent implements OnInit {
  @Input() type: string = '';
  constructor() {}

  ngOnInit(): void {}
}
